import { Button } from "@mui/material";
import { useAppDispatch } from "../../../redux/store";
import { dataBrowserExportCatalogAction } from "../redux/lists.actions";

const ExportButton = () => {
    const dispatch = useAppDispatch();

    const handleExportClick = () => {
        dispatch(dataBrowserExportCatalogAction());
    };

    return (
        <Button
            variant="outlined"
            color="secondary"
            onClick={(e) => {
                e.stopPropagation();
                handleExportClick();
            }}
        >
            Export
        </Button>
    );
};

export default ExportButton;
